import { render, staticRenderFns } from "./AddEducationForm.vue?vue&type=template&id=41945b7e&"
import script from "./AddEducationForm.vue?vue&type=script&lang=ts&"
export * from "./AddEducationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports